module.exports = __webpack_public_path__ + "static/media/vrbus1.c6e7bb86.jpg";